(() => {
  document.documentElement.classList.remove('no-js');
  const narrowFooter = matchMedia('(max-width:600px)');
  let queued = false;
  const updateHeader = () => {
    document.querySelector('[data-hh-header]')?.classList.toggle('is-condensed', window.scrollY > 80);
    queued = false;
  };
  window.addEventListener('scroll', () => {if (!queued) {queued = true; requestAnimationFrame(updateHeader);}}, {passive: true});
  const footerObserver = 'IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion:reduce)').matches && !window.Shopify?.designMode
    ? new IntersectionObserver(entries => entries.forEach(entry => entry.target.classList.toggle('is-revealed', entry.isIntersecting)), {threshold: .03, rootMargin: '0px 0px -15px 0px'}) : null;
  const reserveHeader = () => {
    const header = document.querySelector('[data-hh-header]');
    const wrapper = header?.closest('.shopify-section');
    if (!header || !wrapper) return;
    const condensed = header.classList.contains('is-condensed');
    header.classList.remove('is-condensed');
    wrapper.style.setProperty('--hh-header-reserved-height', `${Math.ceil(header.getBoundingClientRect().height)}px`);
    header.classList.toggle('is-condensed', condensed);
  };
  const init = () => {
    reserveHeader();
    updateHeader();
    document.querySelectorAll('[data-hh-country]').forEach(select => {if(select.dataset.value)select.value=select.dataset.value;});
    document.querySelectorAll('[data-hh-footer-group]').forEach(group => {
      if (!group.dataset.hhReady) {group.open = !narrowFooter.matches; group.dataset.hhReady = 'true';}
    });
    document.querySelectorAll('.hh-footer').forEach(footer => {
      footer.closest('.shopify-section')?.classList.remove('hh-footer-reveal');
      if (footerObserver && footer.hasAttribute('data-hh-reveal')) {
        footerObserver.observe(footer);
        footer.classList.add('is-reveal-ready');
      } else {
        footer.classList.remove('is-reveal-ready');
        footer.classList.add('is-revealed');
      }
    });
  };
  narrowFooter.addEventListener('change', () => document.querySelectorAll('[data-hh-footer-group]').forEach(group => group.open = !narrowFooter.matches));
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const disclosure = event.target.closest('details[open]');
    if (disclosure) {disclosure.open = false; disclosure.querySelector('summary')?.focus();}
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.hh-desktop-menu > ul > li > details[open],.hh-mobile-menu[open]').forEach(disclosure => {
      if (!disclosure.contains(event.target)) disclosure.open = false;
    });
  });
  document.addEventListener('shopify:block:select', event => {
    let element = event.target;
    while (element) {if (element.tagName === 'DETAILS') element.open = true; element = element.parentElement;}
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('resize', reserveHeader);
  window.addEventListener('load', reserveHeader);
  document.fonts?.ready.then(reserveHeader);
})();
